document.addEventListener("DOMContentLoaded", () => {
  function sameHeightCompare() {
    let compare_max_height = 0;
    let cssSelector =
      ".procomparison-probox .procomparison-itemspec:not(.index-1, .procomparison-proimg) .height_item";
    if ($(window).width() > 749 && $(window).width() < 1000) {
      cssSelector =
        ".procomparison-probox .procomparison-itemspec:not(.index-1) .height_item";
    }
    $(cssSelector).each(function () {
      if (compare_max_height < $(this).height()) {
        compare_max_height = $(this).height();
      }
    });
    $(cssSelector).css({ height: `${compare_max_height}px` });
  }

  function sameHeightCompare1() {
    let compare_max_height1 = 0;
    $(".procomparison-probox .procomparison-itemtitle.index-1 ").each(
      function () {
        console.log($(this).height());
        
        if (compare_max_height1 < $(this).height()) {
          compare_max_height1 = $(this).height();
        }
      }
    );
    if ($(window).width() > 590) {
      $(".procomparison-probox .procomparison-itemspec.index-1 ").css({
        height: `${compare_max_height1 + 40}px`,
      });
    } else {
      $(".procomparison-probox .procomparison-itemspec.index-1 ").css({
        height: `${compare_max_height1}px`,
      });
    }
  }
  sameHeightCompare1();
  sameHeightCompare();
  $(window).resize(function () {
    sameHeightCompare();
  });
});
